// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import logger from "@insite/client-framework/Logger";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";

const useChangeCustomerWithRedirect = () => {
    const history = useHistory();
    const state = useAppSelector(state => ({
        currentLocation: getLocation(state),
        ChangeCustomerPage: getPageLinkByPageType(state, "ChangeCustomerPage")?.url,
    }));
    const returnUrl = state.currentLocation.pathname + state.currentLocation.search;
    const linkUrl = `${state.ChangeCustomerPage}?returnUrl=${encodeURIComponent(returnUrl)}`;
    const navigateToChangeCustomerPageWithRedirect = () => {
        if (!state.ChangeCustomerPage) {
            logger.warn("No url was found for ChangeCustomerPage, defaulting to /ChangeCustomer");
            history.push("/MyAccount/ChangeCustomer");
        } else {
            history.push(linkUrl);
        }
    };
    return { navigateToChangeCustomerPageWithRedirect, linkUrl, returnUrl };
};

export default useChangeCustomerWithRedirect;
